// FetchGigs.js
import React from 'react';
import { useFetchGigs } from '../hooks/DataFetching/useFetchGigs';

export const FetchGigs = () => {
    const { gigs, loading } = useFetchGigs();

    const renderGigsTable = (gigs) => {
        return (
            <table className='table table-striped' aria-labelledby="tabelLabel">
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>GroupId</th>
                        <th>CampaignId</th>
                        <th>GrantedToUserId</th>
                        <th>GrantedToGroupId</th>
                        <th>GisStartDate</th>
                        <th>GigEndDate</th>
                        <th>Compensation</th>
                        <th>GigDescription</th>
                        <th>GigRequirements</th>
                        <th>GigStatus</th>
                        <th>CreatedOn</th>
                    </tr>
                </thead>
                <tbody>
                    {gigs.map(gig =>
                        <tr key={gig.id}>
                            <td>{gig.id}</td>
                            <td>{gig.groupId}</td>
                            <td>{gig.campaignId}</td>
                            <td>{gig.grantedToUserId}</td>
                            <td>{gig.grantedToGroupId}</td>
                            <td>{gig.gigStartDate}</td>
                            <td>{gig.gigEndDate}</td>
                            <td>{gig.Compensation}</td>
                            <td>{gig.gigDescription}</td>
                            <td>{gig.gigRequirements}</td>
                            <td>{gig.gigStatus}</td>
                            <td>{gig.createdOn}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    };

    let contents = loading ? (
        <p>
            <em>Loading...</em>
        </p>
    ) : renderGigsTable(gigs);

    return (
        <div>
            <h1 id="tabelLabel">Gigs</h1>
            <p>This component demonstrates fetching data from the server.</p>
            {contents}
        </div>
    );
};

